import { selectElement } from '../browser/selectElement';

export const DS24CART_WAIT_LAYER_TIMEOUT = 30000;

let ds24cart_is_initialized: boolean;
export function ds24cart_wait_start() {

    if (typeof ds24cart_is_initialized == 'undefined')
    {
        ds24cart_is_initialized = true;
        const d = document.createElement('div');
        d.id = 'ds24art_wait';
        d.className = 'app_cart_closable';
        document.body.appendChild(d);
    }

    selectElement<HTMLElement>('#ds24art_wait', el => el.style.display = '');

    if (typeof window.ds24cart_wait_timeout_handler === 'undefined') {
        window.ds24cart_wait_timeout_handler = false;
    }

    if (window.ds24cart_wait_timeout_handler)
        window.clearTimeout( window.ds24cart_wait_timeout_handler );

    window.ds24cart_wait_timeout_handler = window.setTimeout( ds24cart_wait_stop, DS24CART_WAIT_LAYER_TIMEOUT );
}

export function ds24cart_wait_stop()
{
    selectElement<HTMLElement>('#ds24art_wait', el => el.style.display = 'none');

    if (window.ds24cart_wait_timeout_handler)
        window.clearTimeout( window.ds24cart_wait_timeout_handler );

    window.ds24cart_wait_timeout_handler = false
}